import { render } from "./dewas-arsip.vue?vue&type=template&id=69db0abd"
import script from "./dewas-arsip.vue?vue&type=script&lang=js"
export * from "./dewas-arsip.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__